import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "热门分类",
    links: [
      { label: "热点追踪", path: "/category/hot-tracking" },
      { label: "深度揭秘", path: "/category/deep-dive" },
      { label: "娱乐八卦", path: "/category/entertainment" },
    ],
  },
  {
    title: "更多分类",
    links: [
      { label: "社会万象", path: "/category/society" },
      { label: "科技数码", path: "/category/tech" },
      { label: "财经内幕", path: "/category/finance" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "品牌介绍", path: "/about" },
      { label: "联系我们", path: "/about" },
      { label: "用户口碑", path: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-foreground-950">黑料社区</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注热点事件追踪与深度分析，为您呈现最真实、最有料的资讯内容。还原事实真相，守护公众知情权。
            </p>
          </div>
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-600 cursor-pointer transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 黑料社区 版权所有 | 内容仅供学习交流，不构成任何建议
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}